// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { createListenerMiddleware } from '@reduxjs/toolkit';
import { clientsSlice } from '@shared/data-access/slices/clients';
import { resetTrades } from '@advisor-app/store/slices/trader/trader-slice';

/**
 * Middleware to reset trades when the selected client changes. This ensures that
 * trades are scoped to the active client profile.
 */
export const traderResetMiddleware = createListenerMiddleware();

traderResetMiddleware.startListening({
  actionCreator: clientsSlice.actions.setClient,
  effect: (_, { dispatch }) => {
    // Reset trades when client profile changes
    dispatch(resetTrades());
  },
});
